import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminVerify2FA } from '../../lib/adminApi';
import { saveAdminSession } from '../../lib/adminAuth';

const NAVY = '#0a2540';
const ORANGE = '#F37428';

export default function AdminVerify2FA() {
  const navigate = useNavigate();
  const adminId = parseInt(sessionStorage.getItem('pending_admin_id') || '0');
  const [code, setCode]           = useState('');
  const [trust, setTrust]         = useState(true);
  const [loading, setLoading]     = useState(false);
  const [error, setError]         = useState('');

  if (!adminId) { navigate('/admin/login'); return null; }

  async function handleSubmit(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await adminVerify2FA(adminId, code, trust);
      sessionStorage.removeItem('pending_admin_id');
      saveAdminSession(res.token, res.admin);
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.message || 'Invalid code.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.adminBadge}>ADMIN CONSOLE</div>
        <h1 style={s.heading}>Verify your identity</h1>
        <p style={s.sub}>A 6-digit code was sent to your email address.</p>
        {error && <div style={s.errorBox}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <input style={s.codeInput} type="text" placeholder="000000" maxLength={6}
            value={code} onChange={e => setCode(e.target.value.replace(/\D/g,''))}
            required autoFocus inputMode="numeric" />
          <label style={s.trustLabel}>
            <input type="checkbox" checked={trust} onChange={e => setTrust(e.target.checked)} style={{ marginRight: 8 }} />
            Trust this device for 7 days
          </label>
          <button type="submit" style={s.btn} disabled={loading || code.length !== 6}>
            {loading ? 'Verifying…' : 'Verify →'}
          </button>
          <button type="button" style={s.backBtn} onClick={() => navigate('/admin/login')}>← Back to login</button>
        </form>
      </div>
    </div>
  );
}

const s = {
  page:       { minHeight: '100vh', background: NAVY, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px', fontFamily: "'Inter', system-ui, sans-serif" },
  card:       { background: '#fff', borderRadius: 16, padding: '44px 40px', width: '100%', maxWidth: 380, boxShadow: '0 32px 80px rgba(0,0,0,0.4)' },
  adminBadge: { background: 'rgba(10,37,64,0.06)', border: '1px solid rgba(10,37,64,0.15)', borderRadius: 6, color: NAVY, fontSize: 10, fontWeight: 700, letterSpacing: '0.12em', padding: '3px 10px', display: 'inline-block', marginBottom: 16 },
  heading:    { color: NAVY, fontSize: 22, fontWeight: 700, margin: '0 0 6px' },
  sub:        { color: '#94a3b8', fontSize: 13, margin: '0 0 24px' },
  errorBox:   { background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 8, color: '#dc2626', fontSize: 13, padding: '10px 14px', marginBottom: 16 },
  codeInput:  { width: '100%', textAlign: 'center', fontSize: 32, fontWeight: 700, letterSpacing: '0.3em', padding: '16px', border: '2px solid #e2e8f0', borderRadius: 10, outline: 'none', color: NAVY, boxSizing: 'border-box', marginBottom: 16 },
  trustLabel: { display: 'flex', alignItems: 'center', color: '#64748b', fontSize: 13, marginBottom: 20, cursor: 'pointer' },
  btn:        { background: ORANGE, border: 'none', borderRadius: 8, color: '#fff', cursor: 'pointer', fontSize: 15, fontWeight: 600, padding: '13px', width: '100%', marginBottom: 12 },
  backBtn:    { background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer', fontSize: 13, padding: '8px', width: '100%', textAlign: 'center' },
};
